import { TableContainer } from "@mui/material"
import styles from "../Utils/table.module.css"

const getGroupedHeaders = (columns) => {
    const levels = [];
    let maxDepth = 0;

    for (const col of columns) {
        const path = col.groupPath || [];
        maxDepth = Math.max(maxDepth, path.length);

        path.forEach((label, levelIndex) => {
            if (!levels[levelIndex]) levels[levelIndex] = new Map();

            const groupKey = path.slice(0, levelIndex + 1).join(">");
            if (!levels[levelIndex].has(groupKey)) {
                levels[levelIndex].set(groupKey, {
                    label,
                    colSpan: 0,
                    rowSpan: 1,
                });
            }
        });

        const levelIndex = path.length;
        if (!levels[levelIndex]) levels[levelIndex] = new Map();

        const colKey = col.uniqueName;
        levels[levelIndex].set(colKey, {
            label: col.name,
            colSpan: 1,
            rowSpan: 1,
        });

        for (let i = path.length - 1; i >= 0; i--) {
            const groupKey = path.slice(0, i + 1).join(">");
            const group = levels[i].get(groupKey);
            if (group) group.colSpan += 1;
        }
    }

    columns.forEach((col) => {
        if (!col.groupPath || col.groupPath.length === 0) {
            if (!levels[0]) levels[0] = new Map();
            const key = col.uniqueName;
            levels[0].set(key, {
                label: col.name,
                colSpan: 1,
                rowSpan: maxDepth + 1,
            });
        }
    });

    return levels.map((level) => Array.from(level.values()));
};

const HTML_Table = (props) => {
    const { columns = [], config = {} } = props
    const isDynamicColumnType = config.isDynamic ? config.isDynamic : "CALCULATE";

    const previewHeaders =
        ((!!isDynamicColumnType || (isDynamicColumnType === "CALCULATE"))
            && (columns?.filter?.((column) => !!column?.groupPath))?.length > 0)
            ? getGroupedHeaders(columns)
            : null

    return (

        <TableContainer
            sx={{
                scrollbarWidth: "thin",
                scrollbarColor: "#0000FF #00000000",
                pb: 1
            }}
        >
            {
                !previewHeaders
                    ? (
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    {columns?.map((column, colIndex) => (
                                        <th key={colIndex}>
                                            {column?.name}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {Array.from({ length: 1 })?.map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {columns?.map((column, colIndex) => (
                                            <td key={colIndex}></td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        previewHeaders?.length > 0
                            ? (
                                <table className={styles.table}>
                                    <thead>
                                        {previewHeaders?.map((level, rowIdx) => (
                                            <tr key={rowIdx}>
                                                {level.map((cell, cellIdx) => (
                                                    <th
                                                        key={cellIdx}
                                                        colSpan={cell.colSpan > 1 ? cell.colSpan : undefined}
                                                        rowSpan={cell.rowSpan > 1 ? cell.rowSpan : undefined}
                                                        className={styles.headerCell}
                                                    >
                                                        {cell.label}
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>

                                    <tbody>
                                        {Array.from({ length: 1 })?.map((_, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {columns?.map((column, colIndex) => (
                                                    <td key={colIndex}></td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <></>
                            )
                    )
            }
        </TableContainer>
    )
}

export default HTML_Table
